import Cookies from 'js-cookie';

import { redirectToLogin, verifyAuthToken } from './utils';

/**
 * Verify it the JWT in cookies is valid.
 * Sets the credentials for Cliengo-API calls in case of valid JWT.
 * Redirects to login in case of invalid JWT.
 * @param onAuthenticationVerified a Callback to call when the token is correct
 */
export function validateJwtAndAuthorize(
  onAuthenticationVerified: (jwt: string, isAdmin: boolean) => void
): void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const jwt: string | undefined = Cookies.get('jwt');

  if (!jwt) {
    redirectToLogin();
    return;
  }

  const result = verifyAuthToken(jwt, onAuthenticationVerified);

  if (result) {
    return;
  }
  redirectToLogin();
}
